import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRiskMitigationTrackerData = createAsyncThunk(
  'alix/risk-management-mitigation-table-data',
  async (payload, toolkit) => {
    return await AxiosClient('POST', '/v1/risk-management/risk-mitigation', payload, toolkit)
  },
)

export const getFiltersData = createAsyncThunk(
  'alix/risk-management-filters-data',
  async (payload, toolkit) => {
    return await AxiosClient('POST', '/v1/risk-management/filter/filter-dropdown', payload, toolkit)
  },
)

export const getProductCategoryData = createAsyncThunk(
  'alix/risk-management-product_category-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/filter/category?clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getRiskImpactScatterPlotData = createAsyncThunk(
  'alix/risk-management-impact-scatter-plot',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/risk-impact?category=${payload?.category}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getRiskSupplyChainTreeData = createAsyncThunk(
  'alix/risk-management-supply-chain-network',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/supplier-network?category=${payload.category}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getRiskMapChartData = createAsyncThunk(
  'alix/risk-management-spend-vs-risk-by-region',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/spend-risk/regions?clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getRiskMapChartSalesData = createAsyncThunk(
  'alix/risk-management-spend-vs-risk-by-region-sales-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/total/spend/by-countries?clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
